import { useMutation } from '@tanstack/react-query';
import { showErrorMessage } from '~/domain/utils';
import { OverlappingJobError } from '../errors';
import { PermanentJobsService } from '../services';

export const useCreateOnsiteInterview = () => {
  return useMutation({
    mutationFn: PermanentJobsService.createOnsiteInterviews,
    onError(error) {
      if (error instanceof OverlappingJobError) {
        return;
      }

      showErrorMessage({ error });
    },
  });
};
